import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const CongratulationPage = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    try {
      if (token) {
        const decoded = jwtDecode(token);
        if (decoded && decoded.id) setIsLoggedIn(true);
      }
    } catch (err) {
      setIsLoggedIn(false);
    }
  }, [token]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-orange-50 via-white to-orange-100 px-6">
      {/* ✅ Success Icon */}
      <div className="animate-bounce mb-6">
        <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center border-4 border-green-400 shadow-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>

      {/* ✅ Title */}
      <h1 className="text-3xl font-bold text-gray-800 text-center animate-fadeIn">
        🎉 Congratulations!
      </h1>

      {/* ✅ Message */}
      <p className="text-gray-600 mt-3 text-center max-w-md animate-fadeIn delay-100">
        Your product has been successfully posted and is now live for buyers to
        discover! 🚀
      </p>

      {/* ✅ Guest Tip */}
      {!isLoggedIn && (
        <div className="mt-6 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm max-w-sm text-center animate-fadeIn delay-200">
          💡 <b>Tip:</b> Products posted without logging in may be removed. Logged-in sellers enjoy higher product chance stay and trust!
          <div className="mt-3">
            <button
              onClick={() => navigate("/auth")}
              className="text-orange-600 hover:text-orange-700 font-semibold underline transition"
            >
              Sign up or Log in to secure your listings →
            </button>
          </div>
        </div>
      )}

      {/* ✅ Go Home Button */}
      <button
        onClick={() => navigate("/")}
        className="mt-8 bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-3 rounded-xl shadow-lg transition transform hover:scale-105 animate-fadeIn delay-300"
      >
        Go to Home 🏠
      </button>
    </div>
  );
};

export default CongratulationPage;
